import { 
    LOAD_A_SYSTEM_SETTING, ADD_NEW_SYSTEM_SETTING, UPDATE_A_SYSTEM_SETTING, DELETE_A_SYSTEM_SETTING, 
    CLEAR_A_SYSTEM_SETTING_DETAIL, CLEAR_SYSTEM_SETTING_ACTION_STATUS,
} from '../actionTypes';
import { SUCCESS_STATUS, FAILED_STATUS } from '../../constants';

const initialState = {
    systemSettingDetail: null,
    loading: false,
    error: '',
    actionStatus: undefined,
    actionMsg: ""
};

export default function(state = initialState, action) {
    switch(action.type) {
        case LOAD_A_SYSTEM_SETTING: {
            return {
                ...state,
                systemSettingDetail: action.payload
            }
        }

        case ADD_NEW_SYSTEM_SETTING: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }

            return {
                ...state,
                loading: false,
                systemSettingDetail: action.payload.data,
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case UPDATE_A_SYSTEM_SETTING: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }

            return {
                ...state,
                loading: false,
                systemSettingDetail: action.payload.data,
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case DELETE_A_SYSTEM_SETTING: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }
            
            return {
                ...state,
                loading: false,
                systemSettingDetail: null,
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case CLEAR_A_SYSTEM_SETTING_DETAIL: {
            return {
                ...state,
                systemSettingDetail: null,
            }
        }

        case CLEAR_SYSTEM_SETTING_ACTION_STATUS: {
            return {
                ...state,
                actionStatus: undefined,
                actionMsg: ""
            }
        }

        default:
            return state
    }
}